import { render, staticRenderFns } from "./TypeFilePNGIcon.vue?vue&type=template&id=e20b0376&"
import script from "./TypeFilePNGIcon.vue?vue&type=script&lang=js&"
export * from "./TypeFilePNGIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports